import React from 'react';
import { motion } from 'framer-motion';

export default function ScrollReveal({ children, delay = 0.2 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }} // Começa invisível e 50px para baixo
      whileInView={{ opacity: 1, y: 0 }} // Quando aparece na tela: sobe e fica visível
      viewport={{ once: true, margin: "-100px" }} // Anima só uma vez
      transition={{ duration: 0.6, delay: delay, ease: "easeOut" }} // Duração suave
    >
      {children}
    </motion.div>
  );
}